import { DiceCandidateRecord } from 'wisestep-api';
const getCandidateLocation = (candidate: DiceCandidateRecord) => {
  let location = candidate.city;
  location += candidate.city ? ', ' : '';
  location += candidate.region ? candidate.region : '';
  location += candidate.region || candidate.region ? ', ' : '';
  location += candidate.country ? candidate.country : '';
  return location;
};

const getWillingToRelocate = (candidate: DiceCandidateRecord) => {
  let willingToRelocate = 'Not willing to relocate';
  candidate.workPreferences.forEach((workPreference) => {
    if (workPreference.willingToRelocate) {
      willingToRelocate = 'Willing to relocate';
    }
  });
  return willingToRelocate;
};

const getTravelPreference = (candidate: DiceCandidateRecord) => {
  let travelPreference = '0%';
  candidate.workPreferences.forEach((workPreference) => {
    if (workPreference.travelPreference) {
      travelPreference = workPreference.travelPreference + '%';
    }
  });
  return travelPreference;
};

const getWorkPreference = (candidate: DiceCandidateRecord) => {
  const candidateWorkPreference: string[] = [];
  candidate.workPreferences.forEach((workPreference) => {
    if (workPreference.employmentType && workPreference.employmentType.length) {
      workPreference.employmentType.forEach((employmentType) => {
        if (candidateWorkPreference.indexOf(employmentType) === -1) {
          candidateWorkPreference.push(employmentType);
        }
      });
    }
  });
  return candidateWorkPreference.join(', ');
};

const getRate = (candidate: DiceCandidateRecord) => {
  const hourlyRates: string[] = [];
  const annualRates: string[] = [];

  candidate.workPreferences.forEach((workPreference) => {
    if (workPreference.hourlyRate) {
      const hRate = workPreference.hourlyRate;
      let hourlyRate = '';
      if (hRate.min && hRate.max) {
        hourlyRate = hRate.currency + ' ' + hRate.max + ' - ' + hRate.currency + ' ' + hRate.min;
      } else if (hRate.min && !hRate.max) {
        hourlyRate = hRate.currency + ' ' + hRate.min;
      } else if (!hRate.min && hRate.max) {
        hourlyRate = hRate.currency + ' ' + hRate.max;
      }
      hourlyRate += '/Hour';
      if (hourlyRates.indexOf(hourlyRate) === -1) {
        hourlyRates.push(hourlyRate);
      }
    }
    if (workPreference.annualSalary) {
      const aRate = workPreference.annualSalary;
      let annualRate = '';
      if (aRate.min && aRate.max) {
        annualRate = aRate.currency + ' ' + aRate.max + ' - ' + aRate.currency + ' ' + aRate.min;
      } else if (aRate.min && !aRate.max) {
        annualRate = aRate.currency + ' ' + aRate.min;
      } else if (!aRate.min && aRate.max) {
        annualRate = aRate.currency + ' ' + aRate.max;
      }
      annualRate += '/Annum';
      if (annualRates.indexOf(annualRate) === -1) {
        annualRates.push(annualRate);
      }
    }
  });
  if (hourlyRates.length && annualRates.length) {
    return annualRates.join(', ') + ' | ' + hourlyRates.join(', ');
  } else if (hourlyRates.length && !annualRates.length) {
    return hourlyRates.join(', ');
  } else if (!hourlyRates.length && annualRates.length) {
    return annualRates.join(', ');
  }
  return '';
};

export {
  getCandidateLocation,
  getWillingToRelocate,
  getTravelPreference,
  getWorkPreference,
  getRate,
};
